import React from 'react';
import { Form } from 'react-bootstrap';
import Input from 'react-phone-number-input/input';
import PropTypes from 'prop-types';

import styles from './FormClientContact.module.css';

const FormClientContact = ({ client, setClient, formDisabled }) => {
  const handlePhoneChange = (value) => {
    setClient((prev) => ({
      ...prev,
      phone: value,
    }));
  };

  const handleChange = (e) => {
    setClient((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Form>
      <hr />
      <h3>Client Contact</h3>
      <Form.Label>Contact Preference</Form.Label>
      <br />
      <Form.Check
        inline
        type="radio"
        name="contactPreference"
        label="text"
        value="text"
        checked={client.contactPreference === 'text'}
        onChange={handleChange}
        disabled={formDisabled}
      />
      <Form.Check
        inline
        type="radio"
        name="contactPreference"
        label="e-mail"
        value="email"
        checked={client.contactPreference === 'email'}
        onChange={handleChange}
        disabled={formDisabled}
      />
      <br />
      <Form.Label>Cell Phone</Form.Label>
      <Form.Control
        as={Input}
        country="US"
        value={client.phone}
        onChange={(value) => handlePhoneChange(value)}
        placeholder="(704) 123-4567"
        name="phone"
        disabled={client.contactPreference !== 'text' || formDisabled}
      />
      <Form.Label>E-mail Address</Form.Label>
      <Form.Control
        type="email"
        value={client.email}
        onChange={handleChange}
        name="email"
        placeholder="example@example.com"
        className={styles.emailInput}
        disabled={client.contactPreference !== 'email' || formDisabled}
      />
    </Form>
  );
};

FormClientContact.propTypes = {
  client: PropTypes.shape({
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    contactPreference: PropTypes.string.isRequired,
  }).isRequired,
  setClient: PropTypes.func.isRequired,
  formDisabled: PropTypes.bool.isRequired,
};

export default FormClientContact;
